import React from "react";
import ContactSection  from "~sections/contact/ContactOne/ContactSection";
import FooterTwo from '~sections/project/FooterTwo'
import { PageWrapper } from "~components/Core";
import HeaderButton from "~sections/project/Header"

const header = {
  headerClasses: "site-header site-header--menu-start light-header site-header--with-border site-header--sticky",
  containerFluid:true,
  buttonBlock: (
    <HeaderButton
      className="ms-auto d-none d-xs-inline-flex"
      btnOneText="Login"
      btnTwoText="Sign up for early access"
      mr="15px"
      mrLG="0"
    />
  )
}
export default function contactOne() {
  return (
    <PageWrapper  headerConfig={header} innerPage={true}>
        <ContactSection/>
        <FooterTwo/>
    </PageWrapper>
  )
}
